export default function getRoutePrefix(pathname) {
  // Remove leading/trailing slashes and split
  const segments = pathname.replace(/^\/+|\/+$/g, "").split("/");
  // Get first non-empty segment or return "/" for root
  const firstSegment = segments.find(Boolean) || "/";

  return firstSegment;
}
